import { gql } from "apollo-boost";

const QUERY = gql`
  query PortalUserDetails($userId: ID!) {
    portalUser(id: $userId) {
      first_name
      last_name
      ssn_last_four
      dob
      application_status
      billing_address {
        street
        city
        state
        zip
        country
      }
      shipping_address {
        street
        city
        state
        zip
        country
      }
      email
      phone_number
      current_step
      completion_status
      credit_limit
      last_update
      identity_status
      alloy_link
      galileo_prn
      rejection_reason
      referral_code
      start_link
      password_reset_link
      steps {
        name
        key
        number
        complete
      }
      application {
        last_completed_step
        basic_info
        link_bank
        personal_information
        address
        student
        verify_id
        verify_phone
        confirm
        terms_accepted
        dashboard_terms_accepted
        pp_accepted
        w9_accepted
        metadata
      }
      events {
        name
        metadata
        created_at
        updated_at
      }
      card {
        activated
        issued
        galileo_card_status
        metadata
        last_four_digits
      }
      accounts
      metadata
      tags
      is_student
      asset_report {
        report {
          date_generated
          days_requested
          items {
            accounts {
              name
              owners
              account_id
              type
              subtype
              balances {
                current
              }
              historical_balances {
                current
                date
              }
            }
          }
        }
      }
      transaction_report
      derived_financial_data {
        currentBalance
        otherCredit
        otherCreditCard
        minCreditCardLimit
        oldestBankAge
      }
      bank_accounts {
        account_id
        finicity_account_id
        name
        type
        aggregatorType
        institution
        lastFour
        status
        accountNumber
        routingNumber
        payment_method_id
        mask
        balances {
          current_balance
          available_balance
          created_at
        }
        averageBalance
        newlyAdded
        payment_method_id
        unlinked
      }
      default_payment_method {
        finicity_account_id
        plaid_account_id
        unlinked
        id
      }
      payment_methods {
        plaid_account_id
        finicity_account_id
        account_number_last_four
        institution
        nickname
        type
        id
      }
      id
      notes {
        id
        agent_name
        agent_id
        body
        body_text
        tags
        created_at
      }
      ip_addresses {
        ip_address
        session_id
        created_at
        updated_at
        browser
        os
        device_type
        city
        subdivisions
        postal
        country
      }
      sentilink {
        transaction_id
      }
      rewards {
        available_points
        pending_points
      }
      underwritingDecisionReport
      autopay_day
      products
    }
  }
`;

export default QUERY;
